import { setSseConfig } from 'APP/packages/streamApi';
import Entities from 'STORE';

interface ISetAuthTokensParams {
  apiToken: string;
  sseToken: string;
}

export const setAuthTokens = (params: ISetAuthTokensParams): void => {
  setSseConfig({ token: params.sseToken });
  Entities.authStore.setStreamToken(params.sseToken);
};
